import { OCCUPANCY_TYPE } from "@covertree/consts";

export const getOptionsForOccupancyType = () => {
  return OCCUPANCY_TYPE.map((occupancyType) => ({
    value: occupancyType,
    label: occupancyType,
  }));
};
